var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.desafio ? _c('div', [_c('b-row', [_c('b-col', [_c('b-card', {
    staticClass: "header-marcar_consulta bg-gradient-primary"
  }, [_c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', [_c('h1', [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "ShieldIcon",
      "size": "30"
    }
  }), _vm._v(" Avaliar Patrulha em Foco ")], 1)])], 1)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('h2', {
    staticClass: "mt-1"
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "SettingsIcon",
      "size": "30"
    }
  }), _vm._v(" Aluno: " + _vm._s(_vm.obterNomeDosAlunos()) + " ")], 1)])], 1), _c('b-row', {
    staticClass: "mt-1"
  }, [_c('b-col', [_c('b-card', [_c('b-row', [_c('b-col', [_c('div', {
    staticClass: "mb-5"
  }, [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Respostas do Desafio")]), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v(" Anexos "), _c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PaperclipIcon",
      "size": "14"
    }
  })], 1), _c('b-row', _vm._l(_vm.desafio.anexos, function (anexo, index) {
    return _c('b-col', {
      key: index,
      attrs: {
        "cols": "4"
      }
    }, [_vm.isImage(anexo) ? _c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": _vm.getUrlImage(anexo.attached)
      }
    }) : _vm._e(), _vm.isVideo(anexo) ? _c('a', {
      staticClass: "img-fluid",
      attrs: {
        "href": 'data:' + anexo.attached.type + ';base64,' + anexo.attached.content
      }
    }, [_c('feather-icon', {
      staticClass: "mr-50",
      attrs: {
        "icon": "YoutubeIcon",
        "size": "30"
      }
    }), _vm._v(" Vídeo ")], 1) : _vm._e()]);
  }), 1), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v("Local")]), _c('p', [_vm._v(" " + _vm._s(_vm.desafio.informacaoLocal) + " ")]), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v("Solução")]), _c('p', [_vm._v(" " + _vm._s(_vm.desafio.solucao) + " ")]), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v("Comentários")]), _c('p', [_vm._v(" " + _vm._s(_vm.desafio.comentarios) + " ")]), _c('div')], 1), _c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Avaliação")]), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v("Nota")]), _c('b-form-group', {
    attrs: {
      "label": "",
      "label-for": "pontuacao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "id": "pontuacao",
      "placeholder": "Inserir pontuação",
      "min": "0",
      "max": "10",
      "step": "0.1"
    },
    model: {
      value: _vm.form.score,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "score", $$v);
      },
      expression: "form.score"
    }
  })], 1), _c('h5', {
    staticClass: "mt-2"
  }, [_vm._v("Comentário de Feedback")]), _c('b-form-textarea', {
    attrs: {
      "id": "textarea-default",
      "placeholder": "Inserir descrição",
      "rows": "3"
    },
    model: {
      value: _vm.form.feedback,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "feedback", $$v);
      },
      expression: "form.feedback"
    }
  }), _c('b-form-group', [_c('b-form-checkbox', {
    staticClass: "mt-2",
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.approved,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "approved", $$v);
      },
      expression: "form.approved"
    }
  }, [_c('p', {
    staticClass: "fs-3"
  }, [_vm._v("Aprovado")])])], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-4 pb-5 justify-content-between w-100 m-0"
  }, [_c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "button-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.back();
      }
    }
  }, [_vm._v(" Cancelar ")])], 1), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "button-right",
    attrs: {
      "type": "submit",
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.submit();
      }
    }
  }, [_vm._v(" Salvar Avaliação ")])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }